import * as React from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ColorPicker from './ColorPicker';
import {Action} from '../../../system/buttons';
import Ranges from '../../../system/ranges';
import '../../../App.css';
import {PremiumWrapperOverlay} from '../../PremiumWrapperOverlay';
import HueColorPicker from '../../../system/HueColorPicker';
import {BasicFormElement} from '../../../system/form';

export default class GeometryDashEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props.configuration,
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState !== this.state) {
      this.props.onUpdate({
        ranges: this.state.ranges,
        heartEnabled: this.state.heartEnabled,
        shadowEnabled: this.state.shadowEnabled,
        innerBorderEnabled: this.state.innerBorderEnabled,
        outerBorderEnabled: this.state.outerBorderEnabled,
        innerBorderColor: this.state.innerBorderColor,
        outerBorderColor: this.state.outerBorderColor,
      });
    }
  }

  render() {
    return (
      <>
        <h4>Configured ranges</h4>
        <PremiumWrapperOverlay
          bi={{
            from: 'widget_edit_premium_update',
            id: this.props.id,
          }}
          disabled={!this.props.premiumUpdate}
        >
          <Ranges
            ranges={this.state.ranges}
            onRangesChange={(ranges) => this.setState({ranges})}
            defaultRange={{
              from: 60,
              to: 90,
              color: 100,
            }}
            header={
              <Col md={3}>
                <Form inline>
                  <Col>Color</Col>
                </Form>
              </Col>
            }
            rangeConfiguration={(range, onRangeChange) => (
              <Col md={3} key={range.from}>
                <Form inline>
                  <HueColorPicker
                    color={range.color}
                    onChangeComplete={(color) =>
                      onRangeChange({
                        ...range,
                        color,
                      })
                    }
                  />
                </Form>
              </Col>
            )}
          />
          <Row>&nbsp;</Row>

          <BasicFormElement label={'Heart'}>
            <Form.Check
              type="checkbox"
              onChange={(e) =>
                this.setState({heartEnabled: !this.state.heartEnabled})
              }
              checked={this.state.heartEnabled}
            />
          </BasicFormElement>

          <BasicFormElement label={'Inner border'}>
            <Row>
              <Col md={'auto'}>
                <Form.Check
                  type="checkbox"
                  onChange={(e) =>
                    this.setState({
                      innerBorderEnabled: !this.state.innerBorderEnabled,
                    })
                  }
                  checked={this.state.innerBorderEnabled}
                />
              </Col>
              <Col>
                {this.state.innerBorderEnabled && (
                  <ColorPicker
                    color={this.state.innerBorderColor}
                    onChangeComplete={(innerBorderColor) =>
                      this.setState({innerBorderColor})
                    }
                  />
                )}
              </Col>
            </Row>
          </BasicFormElement>

          <BasicFormElement label={'Outer border'}>
            <Row>
              <Col md={'auto'}>
                <Form.Check
                  type="checkbox"
                  onChange={(e) =>
                    this.setState({
                      outerBorderEnabled: !this.state.outerBorderEnabled,
                    })
                  }
                  checked={this.state.outerBorderEnabled}
                />
              </Col>
              <Col>
                {this.state.outerBorderEnabled && (
                  <ColorPicker
                    color={this.state.outerBorderColor}
                    onChangeComplete={(outerBorderColor) =>
                      this.setState({outerBorderColor})
                    }
                  />
                )}
              </Col>
            </Row>
          </BasicFormElement>

          <BasicFormElement label={'Show shadow'}>
            <Form.Check
              type="checkbox"
              onChange={(e) =>
                this.setState({shadowEnabled: !this.state.shadowEnabled})
              }
              checked={this.state.shadowEnabled}
            />
          </BasicFormElement>
        </PremiumWrapperOverlay>

        <Action
          onClick={() =>
            this.props.onSave({
              ranges: this.state.ranges,
              heartEnabled: this.state.heartEnabled,
              shadowEnabled: this.state.shadowEnabled,
              innerBorderEnabled: this.state.innerBorderEnabled,
              outerBorderEnabled: this.state.outerBorderEnabled,
              innerBorderColor: this.state.innerBorderColor,
              outerBorderColor: this.state.outerBorderColor,
            })
          }
        >
          Save settings
        </Action>
      </>
    );
  }
}
